import React from 'react';
import style from './CartItemsSkeleton.module.scss';

const ROWS = 8;

const CartItemsSkeleton = () => (
  <div>
    {Array.from({ length: ROWS }).map((_, i) => (
      <div key={i} className={style.row}>
        <div className={style.name} />
      </div>
    ))}
  </div>
);

export default CartItemsSkeleton;
